import React from "react";
import { faVideo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function NewInvestigatorBanner() {
  return (
    <>
      <div className="announcement uk-box-shadow-small uk-padding uk-padding-remove-bottom uk-background-muted uk-border-rounded text-body uk-width-1-1">
        <div className="uk-h5 uk-inline red uk-text-center">Watch the 2025 NIAP Webinar Recording!</div>
        <p className="bolder">
          Learn more about the 2025 New Investigator Award Program and gain valuable insights from the interactive Q&A
          session where program leaders address common concerns and strategies for developing a competitive application.
        </p>
        <div className="uk-flex uk-flex-right uk-margin-top ">
          <a
            href="https://www.youtube.com/watch?v=KRryiz40kGw"
            className="uk-button uk-button-primary bolder uk-text-truncate uk-margin-bottom"
            target="_blank"
            rel="noopener noreferrer"
          >
            Watch Recording
            <FontAwesomeIcon icon={faVideo} size="1x" className="uk-text-small uk-margin-small-left" />
          </a>
        </div>
      </div>
    </>
  );
}
